import React from 'react';
import { Outlet, useLocation, Navigate } from "react-router-dom";
import {AuthMiddleware, useAuth} from "../../providers/AuthProvider";
import { Helmet } from "react-helmet";

const AccountLayout = () => {
    const { pathname } = useLocation();
    const {auth} = useAuth();

    const pageTitle = () => {
        if (pathname.includes('password/update')) {
            return 'Update Password'
        } else if (pathname.includes('my-profile')) {
            return 'My Profile'
        } else if (pathname.includes('deactivate')) {
            return 'Deactivate'
        } else if (pathname.includes('settings')) {
            return 'Settings'
        }

        return 'Account'
    }
    if (pathname.includes('password/update') && auth && auth.isClient() && auth.clientOrg()?.requiresSSOProvider()) {
        console.log('AccountLayout')
        return <Navigate to={'../my-profile'} replace />;
    }

    return (
        <AuthMiddleware>
            <Helmet>
                <title>{pageTitle()} | Wripple</title>
            </Helmet>
            <Outlet />
        </AuthMiddleware>
    );
};

export default AccountLayout;